<template>
  <v-menu
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      max-width="290px"
      min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
          :value="dateFormatted"
          :label="label"
          :class="inputClass"
          prepend-icon="mdi-calendar"
          readonly
          v-bind="attrs"
          v-on="on"
          hide-details
      ></v-text-field>
    </template>
    <v-date-picker
        v-model="date"
        type="month"
        no-title
        scrollable
        @change="selectDate"
    />
  </v-menu>
</template>

<script>

import moment from "moment";

export default {
  name: "MonthPicker",
  props: {
    label: {
      type: String,
      default: 'Monat auswählen'
    },
    inputClass: String,
    value: Object,
  },
  data: () => ({
    menu: false,
    date: null,
  }),
  watch: {
    value(newValue) {
      this.date = moment({ year: newValue.year, month: newValue.month - 1}).format('yyyy-MM');
    },
  },
  computed: {
    dateFormatted() {
      return moment(this.date, 'yyyy-MM').format('MMMM yyyy');
    },
  },
  methods: {
    selectDate() {
      this.menu = false;
      const selected = moment(this.date, 'yyyy-MM');
      this.$emit('input', { year: selected.year(), month: selected.month() + 1 });
    },
  },
  mounted() {
    if(this.value) {
      this.date = moment({ year: this.value.year, month: this.value.month - 1}).format('yyyy-MM');
    }
  },
}
</script>

<style scoped>

</style>
